import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CartModal from '../../cart/modal';
import LogoSquare from '../../logo-square';
import { getMenu } from 'lib/burokshop';
import type { Menu } from 'lib/burokshop/types';
import MobileMenu from './mobile-menu';
import { MarketplaceSelector } from './marketplace-selector';
import { BurokDownloadPromo } from './burok-download-promo';
import { UserProfileMenu } from './user-profile-menu';
import { supabase } from '../../../lib/supabase';

export function Navbar() {
  const [menu, setMenu] = useState<Menu[]>([]);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    async function loadMenu() {
      try {
        const menuData = await getMenu('next-js-frontend-header-menu');
        setMenu(menuData);
      } catch (error) {
        console.error('Error loading menu:', error);
        setMenu([]);
      }
    }
    loadMenu();
  }, []);

  useEffect(() => {
    // Vérifier la session utilisateur
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user || null);
    };

    checkUser();

    // Écouter les changements de session
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event: any, session: any) => {
      setUser(session?.user || null);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <nav className="relative flex items-center justify-between p-4 lg:px-6 bg-gradient-to-br from-[#ff0442] via-[#ff1a4d] to-[#ff0442]">
      {/* Mobile: Menu hamburger + Logo */}
      <div className="flex items-center gap-3 md:hidden">
        <div className="flex-none">
          <MobileMenu menu={menu} />
        </div>
        <Link
          to="/"
          className="flex items-center"
        >
          <LogoSquare />
        </Link>
      </div>
      
      {/* Desktop: Logo + Navigation */}
      <div className="hidden md:flex md:flex-1 md:items-center">
        <Link
          to="/"
          className="mr-6 flex items-center"
        >
          <LogoSquare />
        </Link>
        {/* Navigation buttons */}
        <ul className="flex gap-6 text-sm items-center">
          <li>
            <Link
              to="/"
              className="text-white font-medium underline-offset-4 hover:text-neutral-100 hover:underline transition-colors"
            >
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/kiosks"
              className="text-white font-medium underline-offset-4 hover:text-neutral-100 hover:underline transition-colors"
            >
              Kiosks
            </Link>
          </li>
          <li>
            <Link
              to="/search"
              className="text-white font-medium underline-offset-4 hover:text-neutral-100 hover:underline transition-colors"
            >
              Catégories
            </Link>
          </li>
          {menu.length ? (
            menu.map((item: Menu) => (
              <li key={item.title}>
                <Link
                  to={item.path}
                  className="text-white font-medium underline-offset-4 hover:text-neutral-100 hover:underline transition-colors"
                >
                  {item.title}
                </Link>
              </li>
            ))
          ) : null}
        </ul>
      </div>
      
      {/* Right side: Actions */}
      <div className="flex items-center justify-end gap-2 md:gap-3">
        <BurokDownloadPromo />
        <MarketplaceSelector />
        <CartModal />
        {/* Desktop: Afficher le menu utilisateur ou le bouton se connecter */}
        {user ? (
          <div className="hidden md:block">
            <UserProfileMenu />
          </div>
        ) : (
          <Link
            to="/login"
            className="hidden md:inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-white border border-white/30 px-4 py-2.5 text-sm font-semibold text-[#ff0442] shadow-sm transition-all duration-200 hover:bg-neutral-50 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#ff0442]"
            aria-label="Se connecter"
          >
            <span>Se connecter</span>
          </Link>
        )}
      </div>
    </nav>
  );
}



